import { useState } from "react";
import { CalendarDays, ExternalLink, X } from "lucide-react";
import { GENERAL_BODY_MEETING, isGeneralBodyMeetingUpcoming } from "@/lib/generalBodyMeeting";

const GeneralBodyMeetingRibbon = () => {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed || !isGeneralBodyMeetingUpcoming()) return null;

  return (
    <section aria-label="General Body Meeting announcement" className="relative bg-indigo-900 text-white shadow-md">
      <div className="container mx-auto flex flex-col items-start gap-3 py-4 pl-4 pr-16 sm:flex-row sm:items-center sm:justify-center sm:gap-5">
        <CalendarDays className="hidden h-6 w-6 shrink-0 sm:block" aria-hidden="true" />
        <div className="min-w-0">
          <h2 className="text-base font-bold">{GENERAL_BODY_MEETING.title}</h2>
          <p className="text-sm text-indigo-100">
            <time dateTime={GENERAL_BODY_MEETING.dateTime}>
              {GENERAL_BODY_MEETING.dateLabel} · {GENERAL_BODY_MEETING.timeLabel}
            </time>
          </p>
        </div>
        <a href={GENERAL_BODY_MEETING.zoomUrl} target="_blank" rel="noopener noreferrer"
          className="inline-flex min-h-11 items-center gap-2 rounded-lg bg-white px-4 py-2 text-sm font-bold text-indigo-900 hover:bg-indigo-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white">
          Join General Body Meeting on Zoom
          <ExternalLink className="h-4 w-4 shrink-0" aria-hidden="true" />
          <span className="sr-only"> (opens in a new tab)</span>
        </a>
      </div>
      <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss General Body Meeting announcement"
        className="absolute right-2 top-2 flex h-11 w-11 items-center justify-center rounded-lg hover:bg-white/15 focus-visible:outline focus-visible:outline-2 focus-visible:outline-white">
        <X className="h-5 w-5" aria-hidden="true" />
      </button>
    </section>
  );
};

export default GeneralBodyMeetingRibbon;
